
import React, { useState, useEffect } from "react";
import ModalEditarPlato from "./ModalEditarPlato";
import ModalNoEditar from "./ModalNoEditar";
import axios from "axios";

const apiUrlVistaPedidos = process.env.REACT_APP_API_VISTAPEDIDOS;

const diasSemana = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];

function VistaPedidoSemanal() {
  const [error, setError] = useState(null);
  // Estados separados por semana y tipo de comida
  const [pedidosSemanaActualAlmuerzo, setPedidosSemanaActualAlmuerzo] = useState([]);
  const [pedidosSemanaActualCena, setPedidosSemanaActualCena] = useState([]);
  const [pedidosSemanaSiguienteAlmuerzo, setPedidosSemanaSiguienteAlmuerzo] = useState([]);
  const [pedidosSemanaSiguienteCena, setPedidosSemanaSiguienteCena] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalNoEditarOpen, setModalNoEditarOpen] = useState(false);
  const [pedidoAEditar, setPedidoAEditar] = useState(null);
  const [platosDisponibles, setPlatosDisponibles] = useState([]);
  // Obtener todos los platos disponibles (para filtrar por fecha y tipo)
  const [todosPlatos, setTodosPlatos] = useState([]);
  // Corte de edición real para la sede
  const [corteEdicion, setCorteEdicion] = useState({ day: 3, time: "10:00" });
  useEffect(() => {
    const apiUrlMenuSemanals = process.env.REACT_APP_API_MENUSEMANALS;
    axios.get(apiUrlMenuSemanals)
      .then(res => setTodosPlatos(res.data || []))
      .catch(() => setTodosPlatos([]));
  }, []);


  useEffect(() => {
    getVistaPedidos();
    // Obtener corte de edición real para la sede del usuario
    const fetchCorteEdicion = async () => {
      try {
        const idSede = localStorage.getItem("id_sede");
        const token = sessionStorage.getItem("token");
        console.log('[VistaPedidoSemanal] Cargando config cutoff para sede:', idSede);
        const resp = await fetch(`${process.env.REACT_APP_API_URL}/config/cutoff`, {
          headers: { "Authorization": `Bearer ${token}` }
        });
        if (resp.ok) {
          const data = await resp.json();
          console.log('[VistaPedidoSemanal] Configuraciones recibidas:', data);
          let corte = data?.[`CUTOFF_EDIT_SEDE_${idSede}`] || data?.CUTOFF_EDIT_DEFAULT || data?.CUTOFF_DEFAULT;
          console.log('[VistaPedidoSemanal] Corte de edición seleccionado:', corte);
          if (corte && typeof corte.day === "number" && typeof corte.time === "string") {
            setCorteEdicion({ day: corte.day, time: corte.time });
            console.log('[VistaPedidoSemanal] Corte aplicado:', { day: corte.day, time: corte.time });
          }
        } else {
          console.error('[VistaPedidoSemanal] Error al cargar config:', resp.status, resp.statusText);
          setCorteEdicion({ day: 3, time: "10:00" });
        }
      } catch (e) {
        console.error('[VistaPedidoSemanal] Excepción al cargar config:', e);
        // fallback default
        setCorteEdicion({ day: 3, time: "10:00" });
      }
    };
    fetchCorteEdicion();
  }, []);

  // Helper para formatear fecha a YYYY-MM-DD
  const fmt = (d) => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  // Calcular rangos de semana actual y próxima para mostrar en títulos (lunes a domingo)
  const hoy = new Date();
  const diaSemana = hoy.getDay();
  const lunes = new Date(hoy);
  lunes.setDate(hoy.getDate() - ((diaSemana + 6) % 7));
  const domingo = new Date(lunes);
  domingo.setDate(lunes.getDate() + 6);

  const lunesStr = fmt(lunes);
  const domingoStr = fmt(domingo);

  const lunesProx = new Date(lunes);
  lunesProx.setDate(lunesProx.getDate() + 7);
  const domingoProx = new Date(lunesProx);
  domingoProx.setDate(lunesProx.getDate() + 6);

  const lunesProxStr = fmt(lunesProx);
  const domingoProxStr = fmt(domingoProx);

  const getVistaPedidos = async () => {
    try {
      // nombreUsuario contiene el username real (ej: "pperalta"), no el nombre display
      const usuario = localStorage.getItem('nombreUsuario');
      if (!usuario) {
        console.warn('No hay usuario logueado en localStorage');
        return;
      }
      console.log('Usuario logueado (localStorage - username):', usuario);

      const response = await axios.get(`${apiUrlVistaPedidos}${usuario}`);
      // response.data contiene todos los pedidos; filtramos por semana abajo
      console.log('VistaPedidoSemanal: respuesta recibida, total pedidos =', response.data?.length);
      try {
        console.table((response.data || []).map(o => ({ id: o.id_pedido, fecha: o.fecha, nombre: o.nombre })));
      } catch (err) {
        // ignore table errors
      }

      // función robusta para parsear distintos formatos de fecha que el backend pueda devolver
      const parseDateValue = (val) => {
        if (!val) return null;
        // si ya es número (timestamp en ms)
        if (typeof val === 'number') return new Date(val);
        if (typeof val === 'string') {
          // buscar patrón YYYY-MM-DD
          const match = val.match(/\d{4}-\d{2}-\d{2}/);
          if (match) return new Date(match[0] + 'T00:00:00');
          // intentar parseo ISO completo
          const dIso = new Date(val);
          if (!isNaN(dIso)) return dIso;
          // intentar número en string
          const n = Number(val);
          if (!isNaN(n)) return new Date(n);
        }
        return null;
      };

      const semanaActualAlmuerzo = [];
      const semanaActualCena = [];
      const semanaSiguienteAlmuerzo = [];
      const semanaSiguienteCena = [];

      const usuarioLogueado = localStorage.getItem('nombreUsuario');
      const normalizeUser = v => (v === null || v === undefined) ? '' : String(v).trim().toLowerCase();
      const usuarioNorm = normalizeUser(usuarioLogueado);

      console.log('[VistaPedidoSemanal] Total pedidos recibidos:', response.data?.length || 0);
      console.log('[VistaPedidoSemanal] Usuario buscando:', usuarioNorm);
      console.log('[VistaPedidoSemanal] Rango semana actual:', lunesStr, '-', domingoStr);
      console.log('[VistaPedidoSemanal] Rango semana próxima:', lunesProxStr, '-', domingoProxStr);

      (response.data || []).forEach(order => {
        // 1. Filtrar por usuario usando asociación normalizada
        const usuarioDelPedido = order.usuarioInfo?.usuario || order.usuario;
        const nombreUserDelPedido = order.usuarioInfo?.nombreuser || order.nombreuser;

        const byUsuario = normalizeUser(usuarioDelPedido) === usuarioNorm;
        const byNombreUser = normalizeUser(nombreUserDelPedido) === usuarioNorm;
        console.log('[VistaPedidoSemanal] Pedido:',
          'fecha:', order.fecha,
          'usuario:', usuarioDelPedido,
          'nombreuser:', nombreUserDelPedido,
          'byUsuario:', byUsuario,
          'byNombreUser:', byNombreUser,
          'comida:', order.comida,
          'id_sede:', order.id_sede,
          'sede:', order.sede?.nombre_sede || 'sin sede'
        );
        if (!byUsuario && !byNombreUser) {
          console.log('[VistaPedidoSemanal] ❌ RECHAZADO por usuario no coincide');
          return;
        }
        console.log('[VistaPedidoSemanal] ✅ ACEPTADO por usuario');

        // 2. Normalizar fecha del pedido a YYYY-MM-DD
        let pStr = '';
        if (typeof order.fecha === 'string') {
          pStr = order.fecha.split('T')[0];
        } else {
          pStr = fmt(new Date(order.fecha));
        }

        if (!pStr) return;

        // Construir nombre del plato/bebida desde asociaciones normalizadas
        let nombreItem = '';
        if (order.plato) {
          nombreItem = order.plato.nombre || '';
        } else if (order.bebida) {
          nombreItem = `${order.bebida.marca || ''} - ${order.bebida.sabor || ''}`.trim();
        } else if (order.nombre) {
          nombreItem = order.nombre; // fallback a campo legacy si existe
        }

        const orderData = {
          ...order,
          fecha: pStr,
          fechaOriginal: pStr,
          nombre: nombreItem, // Agregar nombre construido
          tipo: order.plato?.tipoplato?.nombre || order.tipo || '' // Agregar tipo desde asociación
        };
        const foodType = (order.comida || '').toLowerCase();
        const isLunch = foodType.includes('almuerzo');
        const isDinner = foodType.includes('cena');

        // 3. Clasificar por rango (lunes a domingo)
        if (pStr >= lunesStr && pStr <= domingoStr) {
          if (isLunch) semanaActualAlmuerzo.push(orderData);
          else if (isDinner) semanaActualCena.push(orderData);
        } else if (pStr >= lunesProxStr && pStr <= domingoProxStr) {
          if (isLunch) semanaSiguienteAlmuerzo.push(orderData);
          else if (isDinner) semanaSiguienteCena.push(orderData);
        }
      });

      setPedidosSemanaActualAlmuerzo(semanaActualAlmuerzo);
      setPedidosSemanaActualCena(semanaActualCena);
      setPedidosSemanaSiguienteAlmuerzo(semanaSiguienteAlmuerzo);
      setPedidosSemanaSiguienteCena(semanaSiguienteCena);

      console.log('Semana Actual - Almuerzo:', semanaActualAlmuerzo.length);
      console.log('Semana Actual - Cena:', semanaActualCena.length);
      console.log('Semana Siguiente - Almuerzo:', semanaSiguienteAlmuerzo.length);
      console.log('Semana Siguiente - Cena:', semanaSiguienteCena.length);
    } catch (error) {
      console.error('Error al obtener los pedidos:', error);
      setError('Error al obtener los pedidos.');
    }
  };

  // Función para eliminar toda la semana próxima (almuerzos + cenas)
  const handleEliminarSemanaNueva = async () => {
    // Verificar horario de corte
    const ahora = new Date();
    const corte = new Date(ahora);
    const { day, time } = corteEdicion;
    const [hh, mm] = (time || "10:00").split(":").map(n => parseInt(n, 10));
    const dow = ahora.getDay();
    corte.setDate(ahora.getDate() - dow + day);
    corte.setHours(hh || 10, mm || 0, 0, 0);
    const puedeEliminar = ahora < corte;

    if (!puedeEliminar) {
      setModalNoEditarOpen(true);
      return;
    }

    const todosPedidos = [...pedidosSemanaSiguienteAlmuerzo, ...pedidosSemanaSiguienteCena];
    const totalPedidos = todosPedidos.length;

    if (totalPedidos === 0) {
      alert('No hay pedidos para eliminar en la semana próxima.');
      return;
    }

    const confirmado = window.confirm(`¿Estás seguro que querés eliminar TODOS los pedidos de la semana próxima?\n\nSe eliminarán ${totalPedidos} pedido(s) (almuerzos y cenas).\n\nDespués podrás volver a seleccionar desde cero.`);

    if (!confirmado) return;

    try {
      const apiUrlBase = process.env.REACT_APP_API_URL;

      // Eliminar todos los pedidos de la semana próxima
      const promesas = todosPedidos.map(pedido =>
        axios.delete(`${apiUrlBase}/seleccion/${pedido.id_pedido}`)
      );

      await Promise.all(promesas);

      alert(`Se eliminaron correctamente ${totalPedidos} pedido(s) de la semana próxima.`);
      getVistaPedidos(); // Recargar la lista
    } catch (error) {
      console.error('Error al eliminar pedidos:', error);
      alert('Error al eliminar los pedidos. Intentá de nuevo.');
    }
  };

  // Componente reutilizable para renderizar una tabla de pedidos
  const TablaPedidos = ({ titulo, pedidos }) => {
    // const hoy = new Date();
    // const diaSemana = hoy.getDay();

    const handleEditar = (order) => {
      // Verificar si estamos en período de edición según corte real
      const ahora = new Date();
      const corte = new Date(ahora);
      const { day, time } = corteEdicion;
      const [hh, mm] = (time || "10:00").split(":").map(n => parseInt(n, 10));
      const dow = ahora.getDay();
      corte.setDate(ahora.getDate() - dow + day);
      corte.setHours(hh || 10, mm || 0, 0, 0);
      const puedeEditar = ahora < corte;
      if (!puedeEditar) {
        setPedidoAEditar(order);
        setModalNoEditarOpen(true);
        return;
      }

      // Filtrar platos por fecha, tipo de comida (almuerzo/cena) Y sede del usuario
      const fechaParaBuscar = order.fechaOriginal || order.fecha;
      const tipoComida = (order.comida || '').toLowerCase();
      const sedeUsuario = localStorage.getItem('id_sede');
      const idSedeUsuario = sedeUsuario ? Number(sedeUsuario) : null;

      console.log('🔧 Editando pedido:', order.id_pedido);
      console.log('   - Fecha mostrada (UI):', order.fecha);
      console.log('   - Fecha original (BD):', order.fechaOriginal);
      console.log('   - Fecha para buscar platos:', fechaParaBuscar);
      console.log('   - Tipo comida:', tipoComida);
      console.log('   - Sede usuario:', idSedeUsuario);
      console.log('   - Platos totales en menú:', todosPlatos.length);

      // Mostrar TODOS los platos Y bebidas disponibles para ese día, esa comida Y esa sede
      const platosDiaTipo = todosPlatos.filter(plato => {
        const mismaFecha = plato.fecha === fechaParaBuscar;
        const mismaTipoComida = (plato.comida || '').toLowerCase() === tipoComida;
        const idSedePlato = plato.id_sede != null ? Number(plato.id_sede) : null;
        const mismaSede = idSedeUsuario && idSedePlato && idSedePlato === idSedeUsuario;
        console.log(`   - Comparando plato ${plato.nombre}: fecha=${plato.fecha} (${mismaFecha ? '✅' : '❌'}), comida=${plato.comida} (${mismaTipoComida ? '✅' : '❌'}), id_sede=${plato.id_sede} (${mismaSede ? '✅' : '❌'})`);
        return mismaFecha && mismaTipoComida && mismaSede;
      });

      setPlatosDisponibles(platosDiaTipo);
      setPedidoAEditar(order);
      setModalOpen(true);
    };

    return (
      <div className="mb-8">
        <h3 className="text-lg font-bold mb-4 text-gray-800 bg-gradient-to-r from-purple-100 to-pink-100 px-5 py-3 rounded-xl border-l-4 border-purple-500 shadow-md">
          {titulo}
        </h3>

        {/* Desktop table */}
        <div className="hidden md:block rounded-xl border-2 border-purple-200 overflow-x-auto shadow-lg">
          <table className="w-full text-sm text-left">
            <thead className="bg-gradient-to-r from-purple-500 to-pink-600 text-white font-bold sticky top-0">
              <tr>
                <th className="px-3 py-3">Plato</th>
                <th className="px-3 py-3">Bebida</th>
                <th className="px-3 py-3">Tipo</th>
                <th className="px-3 py-3">Fecha</th>
                <th className="px-3 py-3">Sede</th>
                <th className="px-3 py-3 text-center">Acciones</th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {pedidos.map((order) => (
                <tr
                  key={order.id_pedido}
                  className="border-b border-purple-100 hover:bg-purple-50 transition-colors"
                >
                  <td className="px-3 py-3 font-semibold text-gray-800 max-w-xs truncate">{order.nombre}</td>
                  <td className="px-3 py-3 text-emerald-600 font-medium max-w-xs truncate">
                    {order.bebida ? (
                      <span>{order.bebida.marca} - {order.bebida.sabor}</span>
                    ) : (
                      <span className="text-gray-400 italic">Sin bebida</span>
                    )}
                  </td>
                  <td className="px-3 py-3 text-gray-700 whitespace-nowrap">{order.tipo}</td>
                  <td className="px-3 py-3 text-gray-700 whitespace-nowrap">{order.fecha}</td>
                  <td className="px-3 py-3 whitespace-nowrap">
                    <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded text-xs font-semibold">
                      {order.sede?.nombre_sede || 'Sin sede'}
                    </span>
                  </td>
                  <td className="px-3 py-3 text-center whitespace-nowrap">
                    <div className="flex gap-1.5 justify-center flex-wrap">
                      <button
                        className="px-3 py-2 rounded-md bg-gradient-to-r from-blue-500 to-cyan-600 hover:from-blue-600 hover:to-cyan-700 text-white font-semibold text-xs transition-all shadow-md hover:shadow-lg flex items-center gap-1"
                        onClick={() => handleEditar(order)}
                        title="Editar pedido"
                      >
                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                        <span className="hidden sm:inline">Editar</span>
                      </button>
                      <button
                        className="px-3 py-2 rounded-md bg-gradient-to-r from-red-500 to-orange-600 hover:from-red-600 hover:to-orange-700 text-white font-semibold text-xs transition-all shadow-md hover:shadow-lg flex items-center gap-1"
                        onClick={() => handleEditar(order)}
                        title="Eliminar pedido"
                      >
                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                        <span className="hidden sm:inline">Eliminar</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {pedidos.length === 0 && (
                <tr>
                  <td colSpan={6} className="px-4 py-8 text-gray-500 italic text-center bg-gray-50">
                    No hay pedidos realizados.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Mobile cards */}
        <div className="space-y-4 md:hidden mt-4">
          {pedidos.length === 0 ? (
            <p className="text-gray-600 italic text-center bg-white py-6 rounded-xl shadow-md">No hay pedidos realizados.</p>
          ) : (
            pedidos.map((order) => (
              <div
                key={order.id_pedido}
                className="bg-white border-2 border-purple-200 rounded-2xl shadow-lg p-5 flex flex-col gap-3"
              >
                <p className="text-sm flex items-start gap-2 text-gray-800">
                  <span className="text-lg">🍽</span>
                  <span className="flex-1"><span className="font-bold text-gray-700">Plato:</span> <span className="font-semibold text-gray-900">{order.nombre}</span></span>
                </p>
                <p className="text-sm flex items-start gap-2 text-gray-800">
                  <span className="text-lg">🥤</span>
                  <span className="flex-1"><span className="font-bold text-gray-700">Bebida:</span>
                    <span className="font-semibold text-emerald-600">
                      {order.bebida ? ` ${order.bebida.marca} - ${order.bebida.sabor}` : ' Sin bebida'}
                    </span>
                  </span>
                </p>
                <p className="text-sm flex items-center gap-2 text-gray-800">
                  <span className="text-lg">🍱</span>
                  <span className="font-bold text-gray-700">Tipo:</span> <span className="font-semibold text-gray-900">{order.tipo}</span>
                </p>
                <p className="text-sm flex items-center gap-2 text-gray-800">
                  <span className="text-lg">📅</span>
                  <span className="font-bold text-gray-700">Fecha:</span> <span className="font-semibold text-gray-900">{order.fecha}</span>
                </p>
                <p className="text-sm flex items-center gap-2 text-gray-800">
                  <span className="text-lg">🏢</span>
                  <span className="font-bold text-gray-700">Sede:</span> <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-lg font-semibold text-xs">{order.sede?.nombre_sede || 'Sin sede'}</span>
                </p>
                <div className="flex gap-2 mt-2">
                  <button
                    className="flex-1 px-5 py-3 rounded-xl bg-gradient-to-r from-blue-500 to-cyan-600 hover:from-blue-600 hover:to-cyan-700 text-white font-bold transition-all shadow-lg flex items-center justify-center gap-2"
                    onClick={() => handleEditar(order)}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                    Editar
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-rose-50 py-8 px-4">
      <div className="w-full max-w-7xl mx-auto">
        {/* Header con gradiente */}
        <div className="bg-white rounded-2xl shadow-xl p-6 mb-6 border-b-4 border-purple-500">
          <div className="flex items-center gap-4 mb-2">
            <div className="bg-gradient-to-br from-purple-500 to-pink-600 p-4 rounded-xl shadow-lg">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
              </svg>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-800">Mi Pedido Semanal</h2>
              <p className="text-gray-600">Gestiona tus selecciones semanales</p>
            </div>
          </div>
          <div className="mt-4 flex items-center justify-center gap-2 bg-gradient-to-r from-purple-50 to-pink-50 px-4 py-2 rounded-lg border border-purple-200">
            <span className="text-gray-700 font-medium">Usuario:</span>
            <span className="font-bold text-purple-700">{localStorage.getItem('nombreUsuario')}</span>
          </div>
        </div>

        {error && (
          <div className="bg-red-50 border-2 border-red-300 text-red-700 px-4 py-3 rounded-xl mb-6 text-center font-semibold shadow-md">
            {error}
          </div>
        )}

        {/* Dos columnas: Semana Actual y Semana Próxima.
            Si hay pedidos para la semana próxima, mostrarla primero para que sea lo visible por defecto. */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {(() => {
            const nextCount = pedidosSemanaSiguienteAlmuerzo.length + pedidosSemanaSiguienteCena.length;
            const currentCount = pedidosSemanaActualAlmuerzo.length + pedidosSemanaActualCena.length;
            const showNextFirst = nextCount > 0 && nextCount >= currentCount;


            // Mostrar rango de fechas en los títulos (lunes a domingo)
            const semanaActualRango = `${lunesStr} al ${domingoStr}`;
            const semanaProximaRango = `${lunesProxStr} al ${domingoProxStr}`;

            const SemanaActual = (
              <div key="actual" className="bg-white rounded-2xl shadow-xl p-6 border-2 border-blue-300">
                <div className="flex flex-wrap items-center gap-3 mb-6">
                  <div className="flex items-center gap-2 bg-gradient-to-r from-blue-500 to-cyan-600 px-6 py-3 rounded-xl shadow-lg">
                    <span className="text-2xl">📅</span>
                    <span className="text-xl font-bold text-white">Semana Actual</span>
                  </div>
                  <span className="text-sm font-semibold bg-blue-100 text-blue-800 px-4 py-2 rounded-lg border border-blue-300">{semanaActualRango}</span>
                </div>
                <TablaPedidos titulo="🌅 Almuerzo" pedidos={pedidosSemanaActualAlmuerzo} />
                <TablaPedidos titulo="🌙 Cena" pedidos={pedidosSemanaActualCena} />
              </div>
            );

            const SemanaProxima = (
              <div key="proxima" className="bg-white rounded-2xl shadow-xl p-6 border-2 border-orange-300">
                <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
                  <div className="flex flex-wrap items-center gap-3">
                    <div className="flex items-center gap-2 bg-gradient-to-r from-orange-500 to-red-600 px-6 py-3 rounded-xl shadow-lg">
                      <span className="text-2xl">📆</span>
                      <span className="text-xl font-bold text-white">Semana Próxima</span>
                    </div>
                    <span className="text-sm font-semibold bg-orange-100 text-orange-800 px-4 py-2 rounded-lg border border-orange-300">{semanaProximaRango}</span>
                  </div>
                  {(pedidosSemanaSiguienteAlmuerzo.length > 0 || pedidosSemanaSiguienteCena.length > 0) && (
                    <button
                      onClick={handleEliminarSemanaNueva}
                      className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-bold px-5 py-3 rounded-xl shadow-lg transition-all flex items-center gap-2"
                      title="Eliminar todos los pedidos de la semana próxima (almuerzos y cenas)"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                      Eliminar semana
                    </button>
                  )}
                </div>
                <TablaPedidos titulo="🌅 Almuerzo" pedidos={pedidosSemanaSiguienteAlmuerzo} />
                <TablaPedidos titulo="🌙 Cena" pedidos={pedidosSemanaSiguienteCena} />
              </div>
            );

            return showNextFirst ? [SemanaProxima, SemanaActual] : [SemanaActual, SemanaProxima];
          })()}
        </div>

        {/* Modales */}
        <ModalEditarPlato
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          platosDisponibles={platosDisponibles}
          pedido={pedidoAEditar}
          onSelect={async (item) => {
            if (!pedidoAEditar) return;
            try {
              const apiUrlPedidos = process.env.REACT_APP_API_PEDIDOS || 'http://localhost:8085/api/seleccion/';

              // Determinar si es plato o bebida
              const isPlato = item.id_plato != null;
              const isBebida = item.bebida_id != null;

              const datos = {
                fecha: pedidoAEditar.fechaOriginal || pedidoAEditar.fecha,
              };

              if (isPlato) {
                datos.id_plato = item.id_plato;
                datos.nombre = item.nombre;
              } else if (isBebida) {
                datos.bebida_id = item.bebida_id;
                datos.nombre = item.nombre || `${item.marca} - ${item.sabor}`;
              }

              if (pedidoAEditar.id_pedido) {
                // Editar (PUT)
                await axios.put(`${apiUrlPedidos}${pedidoAEditar.id_pedido}`, datos);
              } else {
                // Crear nuevo pedido (POST)
                datos.usuario = localStorage.getItem('nombreUsuario');
                await axios.post(apiUrlPedidos, datos);
              }
              await getVistaPedidos();
              setModalOpen(false);
            } catch (err) {
              console.error('Error al guardar el pedido:', err);
              alert('Error al guardar el pedido: ' + (err.response?.data?.message || err.message));
              setModalOpen(false);
            }
          }}
        />
        <ModalNoEditar
          open={modalNoEditarOpen}
          onClose={() => setModalNoEditarOpen(false)}
          corteEdicion={corteEdicion}
        />
      </div>
    </div>
  );
}

export default VistaPedidoSemanal;
